import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _IconDot, _IconClose, _IconCheck;
const _excluded = ["sx", "children", "label", "variant", "size", "selected", "includeSelectedIcon"];
import PropTypes from 'prop-types';
import * as React from 'react';
import { useThemeProps } from '@mui/material';
import MuiChip from '@mui/material/Chip';
import { extendSX } from '../helpers';
import { IconCheck, IconClose, IconDot } from '../icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Chip](https://ui-packages.isbuildingluma.com/ui-core/react-chip/)
 *
 * API:
 *
 * - [Chip API](https://ui-packages.isbuildingluma.com/ui-core/api/chip/)
 * - inherits [MuiChip API](https://mui.com/material-ui/api/chip/)
 */
const Chip = /*#__PURE__*/React.forwardRef(function Chip(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'LumaChip'
  });
  const {
      sx,
      label,
      variant,
      size,
      selected,
      includeSelectedIcon
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(MuiChip, _extends({
    ref: ref,
    sx: extendSX(sx, [variant === 'status' && {
      '& .MuiChip-icon': {
        fontSize: 12,
        ml: 0.75
      },
      '& .MuiChip-label': {
        pl: 1.25,
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize'
      }
    }]),
    className: selected ? 'Mui-selected' : undefined
    // Casting because we want to avoid using `ChipPropsSizeOverrides`
    ,
    size: size,
    variant: variant,
    icon: variant === 'status' ? _IconDot || (_IconDot = /*#__PURE__*/_jsx(IconDot, {})) : undefined,
    deleteIcon: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {})),
    label: selected && includeSelectedIcon ? /*#__PURE__*/_jsxs(React.Fragment, {
      children: [_IconCheck || (_IconCheck = /*#__PURE__*/_jsx(IconCheck, {})), label]
    }) : label
  }, rest));
});
process.env.NODE_ENV !== "production" ? Chip.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "ChipProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Render the selected icon.
   * @default false
   */
  includeSelectedIcon: PropTypes.bool,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * Informs if the chip is selected.
   */
  selected: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'status'])
} : void 0;
export default Chip;